// Form to enter details and if match then will get reset password link in email
to reset password
<template>
  <div class="flex items-center min-h-screen w-full  ">
    <div
      class="w-full bg-white rounded shadow-lg p-8  m-4 md:max-w-sm md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center gap-2">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl text-[#C04625]">
             Reset Your Password
            </div>
          </div>
          <p class="text-xs mt-1">
            Enter details to get password reset link
          </p>
          <form class="mt-5 space-y-6" novalidate>
            <div class="rounded-sm">
              <div class="flex flex-col">
                <text-input
                id="attorney_number"
                  label="USL Attorney Number"
                  :class="{ 'border-red-400': v$.form.attorney_number.$error }"
                  :errors="v$.form.attorney_number.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.attorney_number"
                  @blur="form.attorney_number = form.attorney_number?.trim(); v$.form.attorney_number.$touch()"
                  v-on:keyup="form.attorney_number = $event.target['value']"
                ></text-input>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="username"
                  label="Username"
                  :class="{ 'border-red-400': v$.form.username.$error }"
                  :errors="v$.form.username.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.username"
                  @blur="form.username = form.username?.trim(); v$.form.username.$touch()"
                  v-on:keyup="form.username = $event.target['value']"
                ></text-input>
              </div>
              <div
                class="flex flex-col mt-2"
                v-if="password_reset_data?.secret_question"
              >
                <text-input
                id="secret_question"
                  :label="password_reset_data.secret_question"
                  :class="{ 'border-red-400': v$.form.secret_answer.$error }"
                  :errors="v$.form.secret_answer.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.secret_answer"
                  @blur="v$.form.secret_answer.$touch()"
                  v-on:keyup="form.secret_answer = $event.target['value']"
                ></text-input>
              </div>
            </div>
            <div v-if="!this.password_reset_data?.secret_question">
              <button
                id="signin"
                type="button"
                @click="getSecretQuestion"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                <span>Submit</span>
              </button>
            </div>
            <div v-if="this.password_reset_data?.secret_question">
              <button
                id="signin"
                type="button"
                @click="getResetLink"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                <span>Get Reset Link</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  name: "Forgot Password",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function() {
    return {
      form: { username: "", secret_answer: "", attorney_number: "" },
    };
  },
  validations() {
    if (this.password_reset_data?.secret_question) {
      return {
        form: {
          username: {
            required,
          },
          attorney_number: {
            required,
          },
          secret_answer: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          username: {
            required,
          },
          attorney_number: {
            required,
          },
        },
      };
    }
  },
  computed: mapState(["password_reset_data"]),
  created() {
    this.$store.watch(
      () => this.$store.state.is_sent_reset_link,
      (value) => {
        if (value != 0 && value != false) {
          this.$toast.success("Password reset link sent to your email");
          this.form = {};
          this.v$.$reset();
          this.$store.dispatch("resetPasswordData");
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        console.log(value);
        if (value.length != 0) {
          if (value[0].message == "Sorry Answer not match") {
            this.$toast.error("Sorry, Your answer did not match");
          } else {
            this.$toast.error("Attorney not found");
          }
        }
      }
    );
  },
  mounted() {},
  methods: {
    getSecretQuestion: function() {
      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.$store.dispatch("getSecretQuestion", this.form);
    },
    getResetLink: function() {
      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.form.id = this.password_reset_data.id;
      this.$store.dispatch("getResetPasswordLink", this.form);
    },
  },
};
</script>
